import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Spinner } from "components/common";
import IndexMaintenanceStrategiesConfiguration from "components/indices/IndexMaintenanceStrategiesConfiguration";
const _getRotationConfigState = (strategy, data) => ({
  rotation_strategy_class: strategy,
  rotation_strategy: data
});
const _getRetentionConfigState = (strategy, data) => ({
  retention_strategy_class: strategy,
  retention_strategy: data
});
const RotationStrategies = ({
  rotationStrategies,
  indexSetRotationStrategy,
  indexSetRotationStrategyClass,
  disabled = false
}) => {
  if (!rotationStrategies) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement(
    IndexMaintenanceStrategiesConfiguration,
    {
      title: "Index Rotation Configuration",
      name: "rotation",
      description: "Multiple indices are used to store documents, and you can configure the strategy to determine when to rotate the currently active write index.",
      selectPlaceholder: "Select rotation strategy",
      label: "Rotation strategy",
      pluginExports: PluginStore.exports("indexRotationConfig"),
      strategies: rotationStrategies,
      activeConfig: {
        config: indexSetRotationStrategy,
        strategy: indexSetRotationStrategyClass
      },
      getState: _getRotationConfigState,
      disabled
    }
  );
};
const RetentionConfig = ({
  retentionStrategies,
  retentionStrategiesContext,
  indexSetRetentionStrategy,
  IndexSetRetentionStrategyClass,
  disabled = false,
  immutableFields = []
}) => {
  if (!retentionStrategies) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement(
    IndexMaintenanceStrategiesConfiguration,
    {
      title: "Index Retention Configuration",
      name: "retention",
      description: "A retention strategy is used to clean up old indices",
      selectPlaceholder: "Select retention strategy",
      label: "Retention strategy",
      pluginExports: PluginStore.exports("indexRetentionConfig"),
      strategies: retentionStrategies,
      retentionStrategiesContext,
      activeConfig: {
        config: indexSetRetentionStrategy,
        strategy: IndexSetRetentionStrategyClass
      },
      getState: _getRetentionConfigState,
      disabled,
      immutableFields
    }
  );
};
const IndexSetRotationRetentionLegacyConfiguration = ({
  indexSet,
  values,
  rotationStrategies,
  retentionStrategies,
  retentionStrategiesContext,
  hiddenFields,
  immutableFields,
  ignoreFieldRestrictions
}) => {
  const sectionDisabled = immutableFields.includes("legacy");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, indexSet.writable && (!(hiddenFields == null ? void 0 : hiddenFields.includes("legacy.rotation_strategy")) || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    RotationStrategies,
    {
      rotationStrategies,
      indexSetRotationStrategy: values.rotation_strategy,
      indexSetRotationStrategyClass: values.rotation_strategy_class,
      disabled: ((immutableFields == null ? void 0 : immutableFields.includes("legacy.rotation_strategy")) || sectionDisabled) && !ignoreFieldRestrictions
    }
  ), indexSet.writable && (!(hiddenFields == null ? void 0 : hiddenFields.includes("legacy.retention_strategy")) || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    RetentionConfig,
    {
      retentionStrategies,
      retentionStrategiesContext,
      indexSetRetentionStrategy: values.retention_strategy,
      IndexSetRetentionStrategyClass: values.retention_strategy_class,
      disabled: ((immutableFields == null ? void 0 : immutableFields.includes("legacy.retention_strategy")) || sectionDisabled) && !ignoreFieldRestrictions,
      immutableFields
    }
  ));
};
export default IndexSetRotationRetentionLegacyConfiguration;
